<template>
  <v-form v-model="valid" ref="form">
    <v-dialog overlay-opacity="0.7" v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_working')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" @click="deleteComponent(detail)" :loading="loading">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="pt-3 container">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col md="12">
              <v-card-title>
                <span class="headline">{{$t('working_experience')}}</span>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :loading="loading"
                  :headers="headers"
                  :no-data-text="$t('no_data')"
                  :items="workingExperienceList"
                  :hide-default-footer="true"
                >
                  <template v-slot:item.no="{index}">{{index+1}}</template>
                  <template v-slot:item.action="{item}">
                    <v-btn plain class="primary--text" @click="seeDetail(item)">{{$t('see_details')}}</v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-col>
            <v-col md="12" class="pt-0">
              <div class="sae-grey" @click="add">
                <v-icon class="ml-2">mdi-plus</v-icon>
                <span class="ml-4">{{$t('working_experience')}}</span>
              </div>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item>
          <v-row>
            <v-col md="6">
              <v-btn icon @click="tab = 0">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>{{$t('back')}}
            </v-col>
            <v-col md="6" class="text-right" v-if="isEdit">
              <v-btn icon @click="deleteItem(detail)" color="error">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-row align="center">
                <v-divider></v-divider>
                <v-btn plain disabled>{{$t('experience')}}</v-btn>
                <v-divider></v-divider>
              </v-row>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('company_name')"
                v-model="detail.companyName"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-select
                :items="businesList"
                :label="$t('business_industry')"
                v-model="detail.businessTypeId"
                item-text="name"
                item-value="id"
                :rules="rules2"
                required
                class="sae-required"
              ></v-select>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('company_location')"
                v-model="detail.companyLocation"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('last_position')"
                v-model="detail.lastPosition"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-textarea
                :label="$t('job_description')"
                v-model="detail.jobDescription"
                rows="1"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                auto-grow
                required
                class="sae-required"
              ></v-textarea>
            </v-col>
            <v-col md="12">
              <v-text-field :rules="[validator.alfaNumberNotRequired]" :label="$t('achievement')" v-model="detail.achievement" type="text"></v-text-field>
            </v-col>
            <v-col md="6">
              <v-menu
                ref="menu"
                v-model="menuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateFormatted(detail.periodWorkStart)"
                    :label="$t('period_start')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    color="primary"
                    :rules="rules"
                    required
                    class="sae-required"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="detail.periodWorkStart"
                  @change="onStartDateChange"
                  no-title
                  scrollable
                  :locale="$t('locale')"
                  :max="maxDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="6" class="pb-0">
              <v-menu
                ref="menu"
                v-model="menuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateFormatted(detail.periodWorkEnd)"
                   :label="$t('period_end')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    color="primary"
                    :rules="rules"
                    required
                    class="sae-required"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="detail.periodWorkEnd"
                  @change="onEndDateChange"
                  no-title
                  scrollable
                  :locale="$t('locale')"
                  :min="detail.periodWorkStart"
                  :max="maxDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('reason_resignation')"
                v-model="detail.reasonResignation"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-row align="center">
                <v-divider></v-divider>
                <v-btn plain disabled>{{$t('reference')}}</v-btn>
                <v-divider></v-divider>
              </v-row>
            </v-col>
            <v-col md="12">
              <v-text-field
               :label="$t('name')"
                v-model="detail.referenceName"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('position')"
                v-model="detail.referencePosition"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('phoneNumber')"
                v-model="detail.referenceContact"
                type="text"
                :rules="[numberNotRequired]"
              ></v-text-field>
            </v-col>
            <v-col md="12" class="text-center">
              <v-btn plain class="ma-2 primary--text" @click="tab =0">{{$t('cancel')}}</v-btn>
              <v-btn
                color="primary"
                class="ma-2"
                :disabled="!valid"
                :loading="loading"
                @click="saveOrUpdate(detail)"
              >{{$t('save')}}</v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-form>
</template>

<script>
import moment from 'moment'

export default {
  props: ['userId', 'workingExperienceList'],
  name: "Medical-Checkup-List",
  data() {
    return {
      headers: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('position'), value: "lastPosition" },
        { text: this.$i18n.t('company_name'), value: "companyName" },
        { text: this.$i18n.t('company_location'), value: "companyLocation" },
        { text: "", value: "action" },
      ],
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      numberNotRequired: v  => {
        if (v) { if (!v.trim()) return true; } 
        else { return true; }
        if (/^[0-9 .,-]+$/.test(v)) return true;
        return this.$i18n.t('number_required');
      },
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      valid: false,
      formData: [],
      userIdLogin: this.$store.getters.user.id,
      loading: false,
      tab: 0,
      detail: {},
      deleteDialog: false,
      menuStart: false,
      menuEnd: false,
      isEdit: false,
      businesList: [],
      maxDate: moment().locale(this.$i18n.t('lang')).subtract(1, 'day').format('YYYY-MM-DD')
    }
  },
  methods: {
    onStartDateChange() {
      this.menuStart = false;
      if (this.detail.periodWorkEnd) this.detail.periodWorkEnd = this.detail.periodWorkStart
    },
    onEndDateChange() {
      this.menuEnd = false;
    },
    seeDetail(item) {
      this.isEdit = true
      this.detail = Object.assign({}, item)
      this.detail.periodWorkStart = moment(item.periodWorkStart).locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
      this.detail.periodWorkEnd = moment(item.periodWorkEnd).locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
      this.detail.businessTypeId = parseInt(this.detail.businessTypeId)
      this.tab = 1
    },
    add() {
      this.isEdit = false
      this.detail = { userId: this.userId, periodWorkStart: null, periodWorkEnd: null }
      this.tab = 1
    },
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    formatTime(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY")
    },
    dateFormatted(date) {
      if (date) return moment(date).locale(this.$i18n.t('lang')).format('Do MMMM YYYY');
      return null
    },
    async getBusines() {
      this.loading = true
      const result = await this.$store.dispatch('getBusinessType')
      this.loading = false
      return result
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data }
      this.loading = true
      const result = await this.$store.dispatch('saveWorkingExperience', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    async editComponent(data) {
      const body = { ...data }
      this.loading = true
      const result = await this.$store.dispatch('editWorkingExperience', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    deleteItem() {
      this.deleteDialog = true;
    },
    async deleteComponent(data) {
      const body = { ...data, addressType: data.type }
      this.loading = true
      const result = await this.$store.dispatch('deleteWorkingExperience', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_delete'))
        this.$emit('reload', true)
        this.tab = 0
        this.deleteDialog = false
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    refreshData() {
      if (this.workingExperienceList) {
        this.formData = this.workingExperienceList
        this.tab = 0
      } else {
        this.formData = []
        this.tab = 0
        this.detail = { periodWorkStart: null, periodWorkEnd: null }
      }
    },
  },
  async created() {
    this.refreshData()
    this.businesList = await this.getBusines()
  },
  watch: {
    workingExperienceList() {
      this.refreshData()
    },
    userId() {
      this.refreshData()
    },
    tab(tab) {
      if (this.$refs.form && !this.isEdit && tab == 1) {
        this.$refs.form.reset();
      }
    },
  }
}
</script>
<style scoped>
.sae-grey {
  background: #7c8a963d;
  line-height: 35px;
  cursor: pointer;
}
</style>